module.exports = __webpack_public_path__ + "static/media/icon-nomovement.74b83e27.png";